import { ChakraV3, FloatingPopover } from '@piccolohealth/ui';
import React from 'react';
import { useDeleteParticipantBehaviourRecordingMutation } from '../../../graphql/hooks/useDeleteParticipantBehaviourRecordingMutation';
import { useAppContext } from '../../../hooks/useAppContext';

interface Props {
  participantId: string;
  participantBehaviourId: string;
  recordingId: string;
}

export const ParticipantBehaviourRecordingDeleteButton = (props: Props) => {
  const { participantId, participantBehaviourId, recordingId } = props;

  const { organization, successToast, errorToast } = useAppContext();
  const disclosure = ChakraV3.useDisclosure();
  const mutation = useDeleteParticipantBehaviourRecordingMutation();

  const onDelete = React.useCallback(async () => {
    await mutation
      .mutateAsync({
        organizationId: organization.id,
        participantId,
        participantBehaviourId,
        recordingId,
      })
      .then(() => {
        successToast('Participant behaviour recording deleted successfully');
        disclosure.onClose();
      })
      .catch((err) => {
        errorToast(`Error deleting participant behaviour recording: ${err.message}`);
      });
  }, [
    mutation,
    organization.id,
    participantId,
    participantBehaviourId,
    recordingId,
    successToast,
    disclosure,
    errorToast,
  ]);

  return (
    <FloatingPopover
      placement='bottom-start'
      open={disclosure.open}
      setOpen={(isOpen) => (isOpen ? disclosure.onOpen() : disclosure.onClose())}
      render={() => (
        <ChakraV3.Stack w='100%' bg='white' px={6} py={4} gap={4} shadow='2xl' rounded='xl'>
          <ChakraV3.Text>
            Deleting this recording <strong>cannot be undone.</strong>
          </ChakraV3.Text>
          <ChakraV3.Separator />
          <ChakraV3.HStack justify='flex-end'>
            <ChakraV3.Button key='close' onClick={disclosure.onClose} variant='subtle' size='xs'>
              Close
            </ChakraV3.Button>
            <ChakraV3.Button
              onClick={onDelete}
              key='submit'
              colorPalette='red'
              loading={mutation.isLoading}
              loadingText='Deleting...'
              type='submit'
              size='xs'
            >
              Delete
            </ChakraV3.Button>
          </ChakraV3.HStack>
        </ChakraV3.Stack>
      )}
    >
      <ChakraV3.Button size='xs' variant='plain' color='danger'>
        Delete
      </ChakraV3.Button>
    </FloatingPopover>
  );
};
